'use client'

import React, { useEffect, useRef, useState } from 'react'

/**
 * Footer "Call Us" block. Slides left/right with decreasing amplitude (damped),
 * playing once the first time it scrolls into view.
 */
export default function FooterCallUs({ phone }: { phone: string }) {
  const ref = useRef<HTMLDivElement>(null)
  const [play, setPlay] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setPlay(true)
            io.disconnect()
          }
        }
      },
      { threshold: 0.4 },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  return (
    <div
      ref={ref}
      className={`flex flex-col items-center text-center gap-1 xl:flex-row xl:items-center xl:text-left xl:gap-2 transition-transform duration-200 hover:scale-105${
        play ? ' swing-in' : ''
      }`}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        alt="Phone"
        aria-hidden
        className="h-5 w-5 shrink-0 object-contain mb-[10px]"
        src="/footer/phone.svg"
        width={20}
        height={20}
      />
      <div className="text-[17px]">
        <div className="font-semibold leading-[17px] mt-[8px] mb-[5px]">
          Call Us
          <br />
          Today
        </div>
        <a className="font-medium cursor-pointer " href={`tel:${phone}`}>
          {phone}
        </a>
      </div>
    </div>
  )
}
